var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "visible-transition",
    {
      attrs: { duration: 500 },
      on: {
        "before-leave": function($event) {
          _vm.leaving = true
        },
        "after-leave": function($event) {
          _vm.leaving = false
        }
      }
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showOrder || _vm.showPayment,
              expression: "showOrder || showPayment"
            }
          ],
          staticClass: "cog-payment cog-section",
          class: "cog-payment--" + _vm.paymentProcessor
        },
        [
          _c(
            "div",
            { staticClass: "cog-section__inner" },
            [
              _vm.showHeader
                ? [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: "cog-fade",
                          mode: "out-in",
                          duration: _vm.leaving ? 500 : 0
                        }
                      },
                      [
                        _vm.isPaymentHeader
                          ? _c("h2", { key: "1", staticClass: "cog-heading" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$resource("payment")) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _c("h2", { key: "2", staticClass: "cog-heading" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$resource("credit-card-authorization")
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "cog-row" }, [
                _c("div", { staticClass: "cog-col cog-col--24" }, [
                  _c(
                    "section",
                    {
                      staticClass:
                        "cog-section__inner cog-section__inner--background"
                    },
                    [
                      _vm.$slots.paymentDetails && _vm.order.Id
                        ? _c(
                            "div",
                            { staticClass: "cog-row" },
                            [_vm._t("paymentDetails")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cog-row cog-payment__content-row" },
                        [
                          _vm.paymentProcessor && _vm.flags.processPayment
                            ? [
                                _c(
                                  "visible-transition",
                                  {
                                    on: { "after-enter": _vm.forceStripeReflow }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showPayment,
                                            expression: "showPayment"
                                          }
                                        ],
                                        staticClass: "cog-col cog-col--12"
                                      },
                                      [
                                        _vm._t("payment", null, {
                                          saveCard: _vm.saveCard
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOrder
                            ? _c("c-order-details", {
                                attrs: {
                                  order: _vm.order,
                                  "show-line-items": _vm.showLineItems,
                                  "show-sub-total": _vm.showSubTotal,
                                  readonly: _vm.readonly,
                                  "order-amount-label": _vm.orderAmountLabel,
                                  cols:
                                    _vm.showPayment &&
                                    _vm.$scopedSlots.payment &&
                                    _vm.flags.processPayment
                                      ? 12
                                      : 24,
                                  "include-fees": _vm.includeFees
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }